<template>
    <div class="cookie-dlg" id="cookie-settings-dlg">
        <div class="d-flex flex-row">
            <div>
                <b>We use the following cookies on our web site:</b><br>
                <ol>
                    <li>Authentication cookies which are required for the site functionality.</li>
                    <li id="ga-opted-in">Google Analytics cookies which are not personally identifiable.
                        <span class="d-inline-block" id="ga-opted-in">You can
                        <a class="inline-link" href="javascript:void(0)" id="btn-cookie-ga-opt-out">opt out from using them</a>.
                        </span>
                    </li>
                    <li id="ga-opted-out" class="d-none">Google Analytics cookies. You opted out from using Google Analytics on this site. <a class="inline-link" href="javascript:void(0)" id="btn-cookie-ga-opt-in">Opt in again?</a>.
                    </li>
                </ol>
            </div>
            <div>
                <p class="flex-grow-1">By clicking "I agree" button you express your consent to store cookies
                    in accordance with <a :href="routes.ABOUT_PRIVACY" target="_blank">Privacy Policy</a>.</p>
                <button class="btn btn-outline-dark btn-sm" id="btn-cookie-consent">I Agree</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import FadingElement from '../utils/FadingElement';
import {Component, Vue} from 'vue-facing-decorator';

import $ from 'jquery';

@Component
export default class CookieDlg extends Vue {
  public readonly routes = {
    ABOUT_PRIVACY: '/about/privacy',
  };
  private body = new FadingElement('#cookie-settings-dlg', 1.0);

  public show() {
    const dlg = $('#cookie-settings-dlg');
    // <body> includes <main> element scrollbar.
    // This code calculates the right offset relative to <body> as diff between <body> and
    // <main> scrollable widths (which is the width of the scroll bar).
    // const rightOffset = document.body.scrollWidth - $('main').get(0).scrollWidth;
    // dlg.css('right', `${rightOffset}px`);
    // Since cookie consent is declared like "col-md-6" (that is, occupies 50% of the page width),
    // we need to adjust its left side as well, otherwise yellow background will be slightly off
    // the splitter between left and right column.
    // dlg.css('padding-left', `${Math.ceil(rightOffset / 2)}px`);
    this.body.toggle(false);
    $('#btn-cookie-consent').on('click', this.onOkClick);
    $('#btn-cookie-ga-opt-out').on('click', gaOptOut);
    $('#btn-cookie-ga-opt-in').on('click', gaOptIn);
    updateGaStatus();
  }

  private onOkClick = () => {
    document.cookie = `CookieConsent=true;max-age=${COOKIE_EXPIRATION_SEC};`;
    this.body.toggle(true);
  }
}

const COOKIE_EXPIRATION_SEC = 7776000; // 90 days

const GA_OPT_OUT_COOKIE_VALUE = 'ga_opt_out=true';

function gaOptOut() {
  // See https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out
  window['ga-disable-UA-1173427-8'] = true;
  // Set cookie to disable GA in future
  document.cookie = `${GA_OPT_OUT_COOKIE_VALUE};max-age=${COOKIE_EXPIRATION_SEC};`;
  updateGaStatus();
}

function gaOptIn() {
  window['ga-disable-UA-1173427-8'] = undefined;
  document.cookie = 'ga_opt_out=';
  updateGaStatus();
}

function hasGaOptOut(): boolean {
  const cookie = document.cookie;
  let result = false;
  if (cookie) {
    cookie.split(';').forEach(function(keyValue) {
      if (keyValue.trim() === 'ga_opt_out=true') {
        result = true;
      }
    });
  }
  return result;
}

function swapVisibility(hide: string, show: string) {
  $(hide).addClass('d-none');
  $(show).removeClass('d-none');
}

function updateGaStatus() {
  if (hasGaOptOut()) {
    swapVisibility('#ga-opted-in', '#ga-opted-out');
  } else {
    swapVisibility('#ga-opted-out', '#ga-opted-in');
  }
}
</script>

<style scoped>
    .cookie-dlg > div {
        justify-content: space-evenly;
    }
</style>
